import React from 'react'
import { connect } from 'react-redux'
import { isNullOrUndefined } from '../../store/storeFunctions';

import ReactModal from 'react-modal';
import AmlUpdateDataPopup from '../reportSections/aml/amlUpdateDataPopup';
import CeeConfirmation from '../search/cee/ceeConfirmation';
import CeeDetailConfirm from '../search/cee/ceeDetailConfirm';
import CeeDecision from '../search/cee/ceeDecision';
import MultiSelect from './multiSelect';
import RequestsPopup from '../marketingList/requestsPopup';
import LienPopup from '../reportSections/liens/lienPopup';
import GeneralAssemblyItemPopup from '../reportSections/generalAssemblies/generalAssemblyItemPopup';
import ModalInner from '../layoutItems/modalInner';
import FinStatementsMultiSelect from '../marketingList/sections/components/finStatementsMultiSelect';
import AmlExplanatoryNotes from '../reportSections/aml/amlExplanatoryNotes';
import RatingExplanatoryNotes from '../reportSections/rating/ratingExplanatoryNotes';
import InformationMessagePopup from './informationMessagePopup';
import WarningMessagePopup from './warningMessagePopup';
import QuickReportFinDataUpdatePopup from '../reportSections/quickReportSections/quickReportFinDataUpdatePopup';
import AddToPortfolioPopup from "../monitoring/addToPortfolioPopup";
import SharePortfolioPopup from "../monitoring/sharePortfolio/sharePortfolioPopup";
import PortfolioConfirmation from "../monitoring/portfolioConfirmationPopup"
import PortfolioCeeCreMonetaryObligationPopup from "../monitoring/portfolioCeeCreMonetaryObligationPopup"
import AlertsExportLimitPopup from "../monitoring/alertsExportLimitPopup"
import SearchSubjectPopup from "../monitoring/createSection/searchSubjectPopup";
import FeedbackPopup from "../feedback/feedbackPopup";
import SharingGroupRemovalConfirmation from '../user/sharingGroupRemovalConfirmation';
import SharingGroupAddGroupPopup from '../user/sharingGroupAddGroupPopup';
import MoveSubjectPopup from "../monitoring/createSection/moveSubjectPopup";
import RenameProfilePopup from "../relationChart/renameProfilePopup";
import CustomEntityPopup from "../relationChart/customEntityPopup";
import CustomRelationPopup from "../relationChart/customRelationPopup";
import CustomSearchPopup from "../relationChart/customSearchPopup";
import LegendPopup from '../relationChart/legendPopup';
import RelationsUnlimitedPopup from '../relationChart/relationsUnlimitedPopup';
import DetailsPopup from '../marketingList/detailsPopup';
import ConfirmationPopup from "./confirmationPopup";
import NewsPopup from "../news/newsPopup";
import LeavingMarketingListPopup from "../marketingList/leavingMarketingListPopup";
import ConsentPopup from './consentPopup';
import AlertsNotesPopup from "../monitoring/alertsNotesPopup";
import SearchTipPopup from './searchTipPopup';
import TemplatesPopup from '../marketingList/templatesPopup';
import RemoveTemplatePopup from '../marketingList/removeTemplatePopup';
import RepiConsentPopup from '../repi/popups/repiConsentPopup';
import RepiReportCreditConfirmationPopup from '../repi/popups/repiReportCreditConfirmationPopup';
import RepiConfirmDataCorrectionPopup from '../repi/popups/repiConfirmDataCorrectionPopup';
import RepiDataCorrectionUpdatesPopup from '../repi/popups/repiDataCorrectionUpdatesPopup';
import RepiAddSubjectValidationErrorsPopup from '../repi/popups/repiAddSubjectValidationErrorsPopup';
import SaveVisualizationPopup from '../relationChart/saveVisualizationPopup';
import LoadVisualizationPopup from '../relationChart/loadVisualizationPopup';

const POPUP_TYPES = {
    'updateAmlData': { bbComponent: AmlUpdateDataPopup, size: 'medium' },
    'ceeConfirmation': { bbComponent: CeeConfirmation, size: 'extra-small' },
    'ceeDetailConfirmation': { bbComponent: CeeDetailConfirm, size: 'medium' },
    'ceeDecision': { bbComponent: CeeDecision, size: 'small' },
    'porfolioBulkConfirmation': { bbComponent: PortfolioConfirmation, size: 'extra-small' },
    'porfolioBulkCeeCreMonetaryObligation': { bbComponent: PortfolioCeeCreMonetaryObligationPopup, size: 'extra-small' },
    'multiSelect': { bbComponent: MultiSelect, size: 'small' },
    'requestsPopup': { bbComponent: RequestsPopup, size: 'medium' },
    'lienPopup': { bbComponent: LienPopup, size: 'large' },
    'generalAssemblyItemPopup': { bbComponent: GeneralAssemblyItemPopup, size: 'large' },
    'finStatementsMultiSelect': { bbComponent: FinStatementsMultiSelect, size: 'large' },
    'ratingExplanatoryNotes': RatingExplanatoryNotes, // not used
    'amlExplanatoryNotes': AmlExplanatoryNotes, // not used
    'informationMessagePopup': { bbComponent: InformationMessagePopup, size: 'small' },
    'warningMessagePopup': { bbComponent: WarningMessagePopup, size: 'small' },
    'quickReportFinDataUpdatePopup': { bbComponent: QuickReportFinDataUpdatePopup, size: 'small-narrow' },
    'leavingMarketingListPopup': { bbComponent: LeavingMarketingListPopup, size: 'small' }, //not used
    'addToPortfolioPopup': { bbComponent: AddToPortfolioPopup, size: 'medium' },
    'sharePortfolio': { bbComponent: SharePortfolioPopup, size: 'small' },
    'searchSubjectPopup': { bbComponent: SearchSubjectPopup, size: 'large' },
    'feedbackPopup': { bbComponent: FeedbackPopup, size: 'small' },
    'sharingGroupRemovalConfirmation': { bbComponent: SharingGroupRemovalConfirmation, size: 'medium' },
    'sharingGroupAddGroupPopup': { bbComponent: SharingGroupAddGroupPopup, size: 'small' },
    'moveSubjectPopup': { bbComponent: MoveSubjectPopup, size: 'medium' },
    'renameProfilePopup': { bbComponent: RenameProfilePopup, size: 'small' },
    'customEntityPopup': { bbComponent: CustomEntityPopup, size: 'medium' },
    'customRelationPopup': { bbComponent: CustomRelationPopup, size: 'medium' },
    'relationsUnlimitedPopup': { bbComponent: RelationsUnlimitedPopup, size: 'medium' },
    'customSearchPopup': { bbComponent: CustomSearchPopup, size: 'small' },
    'legendPopup': { bbComponent: LegendPopup, size: 'large' },
    'detailsPopup': DetailsPopup,
    'confirmationPopup': { bbComponent: ConfirmationPopup, size: 'extra-small' },
    'newsPopup': { bbComponent: NewsPopup, size: 'no-scroll small', closeOnOverlayClick: false },
    'consentPopup': { bbComponent: ConsentPopup, size: 'small', closeOnOverlayClick: false },
    'alertsExportLimitPopup': { bbComponent: AlertsExportLimitPopup, size: 'small' },
    'alertsNotesPopup': { bbComponent: AlertsNotesPopup, size: 'medium' },
    'searchTipPopup': { bbComponent: SearchTipPopup, size: 'medium' },
    'templatesPopup': { bbComponent: TemplatesPopup, size: 'medium' },
    'removeTemplatePopup': { bbComponent: RemoveTemplatePopup, size: 'small' },
    'repiConsentPopup': { bbComponent: RepiConsentPopup, size: 'small' },
    'repiReportCreditConfirmationPopup': { bbComponent: RepiReportCreditConfirmationPopup, size: 'extra-small' },
    'repiConfirmDataCorrectionPopup': { bbComponent: RepiConfirmDataCorrectionPopup, size: 'extra-small' },
    'repiDataCorrectionUpdatesPopup': { bbComponent: RepiDataCorrectionUpdatesPopup, size: 'large' },
    'repiAddSubjectValidationErrorsPopup': { bbComponent: RepiAddSubjectValidationErrorsPopup, size: 'large' },
    'saveVisualizationPopup': { bbComponent: SaveVisualizationPopup, size: 'medium' },
    'loadVisualizationPopup': { bbComponent: LoadVisualizationPopup, size: 'medium' },
}

const mapStateToProps = state => ({
    ...state.popup
})

class PopupContainer extends React.Component {
    render() {
        if (!this.props.popupType)
            return null;

        const SpecifiedPopup = POPUP_TYPES[this.props.popupType].bbComponent || POPUP_TYPES[this.props.popupType];
        const popupSize = this.props.popupProps.popupSize || POPUP_TYPES[this.props.popupType].size || 'large';
        const closeOnOverlayClick = isNullOrUndefined(POPUP_TYPES[this.props.popupType].closeOnOverlayClick) ? true : POPUP_TYPES[this.props.popupType].closeOnOverlayClick;
        return (
            <div>
                <ReactModal isOpen={this.props.popupProps.open} shouldCloseOnOverlayClick={closeOnOverlayClick} ariaHideApp={false} className={`${popupSize}-bb-modal`} onRequestClose={this.props.popupProps.close}>
                    {this.props.popupProps.title ?
                        <ModalInner title={this.props.popupProps.title} close={this.props.popupProps.close} style={this.props.popupProps.style}>
                            <SpecifiedPopup {...this.props.popupProps} />
                        </ModalInner> :
                        <SpecifiedPopup {...this.props.popupProps} />
                    }
                </ReactModal>
            </div>
        )
    }
}

export default connect(mapStateToProps, null)(PopupContainer)